import React from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
const DetailsService = () => {
    const data = useLoaderData()
    const { title, details, image_url, price, rating, } = data;
    console.log(data)
    console.log(title)
    return (
        <>
            <div className="hero bg-base-200 my-5 rounded">
                <div className="grid lg:grid-cols-2 gap-4">
                    <div className='mr-3 pb-5 ml-3'>
                        <h1 className='my-3 text-center font-bold text-2xl'>Services Details</h1>
                        <div className="card card-compact shadow-xl">
                            <figure>
                                {
                                    <PhotoProvider>
                                        <PhotoView src={image_url}>
                                            <img src={image_url} alt="Shoes" className='w-full h-60' />
                                        </PhotoView>
                                    </PhotoProvider>
                                }
                            </figure>
                            <div className="card-body">
                                <h2 className="card-title">{title}</h2>
                                <p>{details}</p>
                                <p>Ratings : {rating}</p>
                                <div className="card-actions justify-end items-center">
                                    <p>Price: {price}tk</p>
                                </div>
                            </div>
                        </div>
                        <Link to='/services'><button className="btn h-8 min-h-8 btn-primary my-3">Back</button></Link>
                    </div>
                    <div>
                        <h1 className='my-3 text-center font-bold text-2xl'>Review</h1>
                        <div className="card w-96 bg-base-100 shadow-xl">
                            <figure className="px-10 pt-10">
                                <img src={image_url} alt="Shoes" className="rounded-xl" />
                            </figure>
                            <div className="card-body items-center text-center">
                                <h2 className="card-title">{title}</h2>
                                <div className="card-actions">
                                    <button className="btn btn-primary">Add Review</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DetailsService;